'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiChartPieOutline = function TiChartPieOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.4 12.7l0.9-0.9c0.7-0.7 1-1.6 1-2.6-0.1-0.9-0.5-1.8-1.2-2.4-3.6-2.9-7.9-4.7-12.5-5.1-0.1 0-0.2 0-0.3 0-0.8 0-1.6 0.3-2.2 0.8-0.7 0.7-1.1 1.6-1.1 2.5v3.7c-6.1 1.5-10.6 7-10.6 13.4 0 7.5 6.2 13.7 13.8 13.7 2.6 0 5.1-0.8 7.4-2.2 0.4 0.2 0.9 0.3 1.5 0.3 0 0 0.1 0 0.1 0 1 0 1.9-0.5 2.5-1.2 2.3-3 3.6-6.7 3.6-10.5 0-3.4-1-6.7-2.9-9.5z m-12.2 19.8c-5.8 0-10.4-4.7-10.4-10.4 0-5.3 3.8-9.6 8.9-10.3v10.7l7.6 7.9c-1.7 1.3-3.8 2.1-6.1 2.1z m0.1-12.5v-15c4.1 0.4 7.7 2 10.6 4.4l-10.6 10.6z m0.4 2.2l8.4-8.4c1.8 2.3 2.9 5.2 2.9 8.4 0 3.2-1.1 6.1-2.9 8.4l-8.4-8.4z' })
        )
    );
};

exports.default = TiChartPieOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/chart-pie-outline.js
// module id = 3550
// module chunks = 0